import { MolsonBox, MolsonDivider } from '@components/reusable'
import {
  DialogActions,
  DialogActionsProps,
  SxProps,
  Theme
} from '@mui/material'

interface MolsonDialogActionsProps extends DialogActionsProps {
  dataTestId?: string
  displayDivider?: boolean
  sx?: SxProps<Theme>
  disableSpacing?: boolean
}

export const MolsonDialogActions = ({
  dataTestId,
  children,
  displayDivider = true,
  disableSpacing = true,
  sx,
  ...props
}: MolsonDialogActionsProps) => {
  const defaultSx = {
    marginTop: displayDivider ? 0 : 3
  }

  return (
    <MolsonBox display="flex" flexDirection="column" gap={2}>
      {displayDivider ? <MolsonDivider orientation="horizontal" /> : null}
      <DialogActions
        disableSpacing={disableSpacing}
        data-testid={dataTestId}
        {...props}
        sx={{ ...defaultSx, ...sx }}
      >
        {children}
      </DialogActions>
    </MolsonBox>
  )
}
